<template>
  <v-card class="jobpost-teaser" outlined color="#f5f5f5" elevation="10">
    <v-toolbar color="#0274b3" dark class="d-flex justify-center card-toolbar">
      <h4 class="text-h4">Mock Job Description</h4>
      <!-- <v-toolbar-title>Mock Job Description</v-toolbar-title> -->
    </v-toolbar>

    <v-card-text class="body-2 black--text job-text">
      <v-row justify="space-between" align="center">
        <v-col cols="12" sm="12" md="9"
          ><h4 class="text-h4 font-weight-bold text-hrng">
            Registered Nurse
          </h4></v-col
        >
        <v-col cols="12" sm="12" md="3">
          <div class="company-logo">
            <v-img
              src="https://hrng-assets.s3.amazonaws.com/HRN_Glogo_09b879e9de.png"
            /></div
        ></v-col>
      </v-row>

      <!-- <div class="d-flex justify-space-between align-center">
        <h4 class="text-h4 font-weight-bold text-hrng">Sales Representative</h4>
        <div class="company-logo">
          <v-img
            src="https://hrng-assets.s3.amazonaws.com/HRN_Glogo_09b879e9de.png"
          />
        </div>
      </div> -->

      <div>
        <h5 class="text-h5 font-weight-bold mb-5">Hire Next Generation</h5>

        <div class="font-weight-bold">Company Information:</div>
        <ul class="list-style-type-none">
          <li>
            A fictional hospital - helping to prepare RN job seeking prospects
            for their video interviews
          </li>
        </ul>

        <div class="font-weight-bold">Work Hours/Shift:</div>
        <ul class="list-style-type-none">
          <li>Full time, 3 12/hr shifts, 7am-7pm</li>
        </ul>

        <div>
          <span class="font-weight-bold pr-1">Requirements:</span>
          <ul class="list-style-type-none">
            <li>Graduate from a school of Nursing</li>
          </ul>
        </div>

        <div class="font-weight-bold">Preferences:</div>
        <ul class="list-style-type-dashed">
          <li>Outstanding customer service</li>

          <li>
            Good interpersonal skills with ability to develop relationships
            quickly
          </li>

          <li>Strong communication skills</li>

          <li>Positive attitude</li>

          <li>Coachable</li>
        </ul>

        <div class="font-weight-bold">Responsibilities:</div>
        <ul class="list-style-type-dashed">
          <li>
            Reports all procedures and assessments in accordance with department
            policy.
          </li>

          <li>
            Interprets and verifies physician orders, investigates questionable
            situations.
          </li>

          <li>
            Provides expert resourcing to staff nurses and other departments as
            consulted.
          </li>

          <li>
            Obtains patient assessment, evaluating diagnosis and previous
            medical history.
          </li>

          <li>Accurately documents and monitors activities as needed.</li>
        </ul>
      </div>
    </v-card-text>

    <v-card-actions class="background-blue">
      <Apply
        v-if="loggedIn"
        mobileButtonText="Apply"
        buttonText="Get Started For Free"
        color="#FC4A46"
        dark
        :candidateId="getUserData.candidate.id"
        :candidateFirstName="getUserData.candidate.firstName"
        :candidateSurname="getUserData.candidate.surname"
      />
      <AuthModal
        v-else
        mobileButtonText="Apply"
        buttonText="Get Started For Free"
        color="#FC4A46"
        dark
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import Apply from '@/components/Apply';
import { authComputed } from '@/store/helpers';
import AuthModal from '@/components/Auth/AuthModal';

export default {
  components: { Apply, AuthModal },
  computed: { ...authComputed },
};
</script>

<style lang="scss">
.jobpost-teaser {
  width: 100%;
  border: none !important;

  .company-logo {
    //width: 100px;
    max-width: 100px;
  }
  .job-text {
    line-height: 1.8rem;
  }
  .card-toolbar {
    height: auto !important;
    .v-toolbar__content {
      height: auto !important;
    }
  }
}
</style>
